@if (boost(); as b) {
  <button
    class="purchase-boost-banner"
    [class.purchase-boost-banner--full]="fullWidth()"
    type="button"
    (click)="openDetails.emit()">
    <ac-icon iconKey="hr:bolt" [size]="16" />
    <span class="ac-label-md purchase-boost-banner__text">{{ bannerText() }}</span>

    @if (includeInfoIcon()) {
      <ac-icon iconKey="hr:info" [size]="16" />
    }
  </button>
}
